import { writable, get } from "svelte/store";
import * as api from "../../utiles/api.js";
import toast from "svelte-french-toast";

const today = new Date();
const fourMonthsLater = new Date();
fourMonthsLater.setMonth(today.getMonth() + 4);

const formatDate = (date) => date.toISOString().split('T')[0];

export const finalInspectionStore = writable({
    list: [],
    selectedItem: null,
    search: {
        prdctn_plan_no: "",
        lot_no: "",
        stndrd_no: "",
        modl_no: "",
        mnfctur_no: "",
        search_korean_nm: "",
        inspct_empno: "",
        startDate: '2025-01-01',
        endDate: '2026-12-31',
        prpert_at: "전체",
        isExpanded: true,
    },
    scrollPos: 0,
});

export const inspectionWaitingStore = writable({
    list: [],
    search: {
        plan_no: "",
        mnfctur_order_no: "",
        item_code: "",
        item_nm: "",
        startDate: '2025-01-01',
        endDate: '2026-12-31',
        inspct_at: "전체",
        lot_no: "",
    },
    modalOpen: false
});

export const appStateStore = writable({
    currentView: "list", // 'list', 'detail', 'waiting'
    selectedId: null,
});

export const inspectionClassStore = writable({
    list: [],
    selectedCode: "",
});

export async function fetchFinalInspectionData(bplc_code, silent = false) {
    const store = get(finalInspectionStore);
    try {
        const params = new URLSearchParams({
            startDate: store.search.startDate || "",
            endDate: store.search.endDate || "",
            prdctn_plan_no: store.search.prdctn_plan_no || "",
            lot_no: store.search.lot_no || "",
            stndrd_no: store.search.stndrd_no || "",
            modl_no: store.search.modl_no || "",
            mnfctur_no: store.search.mnfctur_no || "",
            search_korean_nm: store.search.search_korean_nm || "",
            inspct_empno: store.search.inspct_empno || "",
            prpert_at: store.search.prpert_at === "전체" ? "" : store.search.prpert_at,
        });

        const response = await api.get(`inspection/final/list?${params.toString()}`);

        if (response && response.data) {
            finalInspectionStore.update((s) => ({
                ...s,
                list: response.data,
            }));
            if (!silent) toast.success("최종검사 조회 완료");
        }
    } catch (err) {
        console.error(err);
        if (!silent) toast.error("최종검사 조회 중 오류가 발생했습니다.");
    }
}

export async function fetchClassifications(bplc_code) {
    try {
        const response = await api.get(`inspection/classification/list?bplc_code=${bplc_code}`);
        if (response && response.data) {
            inspectionClassStore.update((s) => ({
                ...s,
                list: response.data,
            }));
        }
    } catch (err) {
        console.error("Failed to fetch classifications:", err);
    }
}
